import React from 'react';
import PropTypes from 'prop-types';

import {
    LatestBlogPosts,
    LayoutRow,
    LayoutRowColumn,
} from '@ratehub/web-components';

import BLOCK_MAP from '../definitions/TemplateCorporateBlockMap';
import createBlogHeroBlocks from '../functions/createBlogHeroBlocks';
import Layout from './Layout';


function BlogAuthorPage({
    author,
    posts,
    hasMorePages,
    articleIDs,
}) {
    const CONTENT = createBlogHeroBlocks(author.name);

    return (
        <Layout
            blocks={CONTENT}
            blockMap={BLOCK_MAP}
        >
            <LayoutRow
                className="rh-layout-default rh-pt-0 rh-pb-4"
                includeContentPadding={false}
            >
                <LayoutRowColumn>
                    <LatestBlogPosts
                        initialPosts={posts}
                        hasMorePages={hasMorePages}
                        include={articleIDs}
                    />
                </LayoutRowColumn>
            </LayoutRow>
        </Layout>
    );
}

BlogAuthorPage.propTypes = {
    author: PropTypes.shape({
        id: PropTypes.number,
        slug: PropTypes.string,
        name: PropTypes.string,
        articles: PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ])),
    }).isRequired,
    posts: PropTypes.array.isRequired,
    hasMorePages: PropTypes.bool.isRequired,
    articleIDs: PropTypes.string.isRequired,
};

export default BlogAuthorPage;
